import React from 'react'
import {FormattedMessage} from 'react-intl'
import ExternalLink from '../../../assets/icons/ExternalLink.svg'
import {UrlPrefix, UserType} from '../../../config/constants'
import CheckField from '../../fields/custom/CheckField'
import {useLocale, useUserType} from '../../hocs/hooks'
import styles from '../login/Login.scss'

const Terms = () => {
  const userType = useUserType()
  const locale = useLocale()
  return <>
    <label className="font-weight-bold col-form-label required">
      <FormattedMessage id="userSignup.agreeTerm"
                        defaultMessage="Agreement to our Term of Service"/>
    </label>
    <p className="small text-muted">
    {
      userType === UserType.user
        ? <FormattedMessage id="driverSignup.termNote"
                            defaultMessage="To register you must agree with our <tos>Term of Service</tos>. Please check the following checkbox."
                            values={{
                              tos: msg => <a href={`/${locale}${UrlPrefix.user}/contract`}
                                             rel="noopener noreferrer"
                                             className={styles.underlineLink}
                                             target="_blank">
                                {msg}
                                <ExternalLink className="fa ml-1 mb-1"/>
                              </a>
                            }}/>
      : userType === UserType.holder
      ? <FormattedMessage id="holderSignup.termNote"
                          defaultMessage="To register you must agree with our <tos>Term of Service</tos>. Please check the following checkbox."
                          values={{
                            tos: msg => <a href={`/${locale}/contract`}
                                           rel="noopener noreferrer"
                                           className={styles.underlineLink}
                                           target="_blank">
                              {msg}
                              <ExternalLink className="fa ml-1 mb-1"/>
                            </a>
                          }}/>
      : userType === UserType.host
      ? <FormattedMessage id="hostSignup.termNote"
                        defaultMessage="To register you must agree with our <tos>Term of Service</tos>. Please check the following checkbox."
                        values={{
                          tos: msg => <a href={`/${locale}${UrlPrefix.host}/contract`}
                                          rel="noopener noreferrer"
                                          target="_blank">
                            {msg}
                            <ExternalLink className="fa ml-1 mb-1"/>
                          </a>
                        }}/>
      : <FormattedMessage id="userSignup.termNote"
                        defaultMessage="To register you must agree with our <tos>Term of Service</tos>. Please check the following checkbox."
                        values={{
                          tos: msg => <a href={`/${locale}/contract`}
                                          rel="noopener noreferrer"
                                          target="_blank">
                            {msg}
                            <ExternalLink className="fa ml-1 mb-1"/>
                          </a>
                        }}/>
    }
    </p>
    <div className="form-group font-weight-bold">
      <CheckField name="agreeContract">
        <FormattedMessage id="userSignup.agreeToContract"
                          defaultMessage="I agree to the Carstay's Term of Service"/>
      </CheckField>
    </div>
  </>
}
Terms.displayName = 'Terms'
export default Terms
